'use strict';

var React = require('react');

var SvgRichTextMinor = function SvgRichTextMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5h-5Zm13.5 4h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2Zm-4 4h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2Zm4 4h-14a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2Zm-3.293 3.707a1 1 0 0 1-.707.293h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 .707 1.707Z"
  }));
};

exports.SvgRichTextMinor = SvgRichTextMinor;
